import { ICON_DROP_PX, iconDropPx } from './IconDrop/iconDropScale';
import { DESKTOP_PX, desktopPx } from './DeviceFallback/desktopFallbackScale';
import { THANK_YOU_ACCENT_DEFAULT } from '../utils/thankYouCopy';

// Copy resolution lives in utils/thankYouCopy.ts; this file keeps the JSX
// store-line renderers used by the mobile/desktop shells and re-exports the
// resolver so existing importers keep compiling.
export {
  THANK_YOU_ACCENT_DEFAULT as THANK_YOU_ACCENT,
  resolveThankYouAccentColor,
  thankYouCopy,
  resolveThankYouEyebrow,
} from '../utils/thankYouCopy';
export type { ThankYouCopy } from '../utils/thankYouCopy';

interface ThankYouStoreLineProps {
  gameName: string;
  storePlatform: string;
  /** Accent for the {game}/{store} words; defaults to #D821D4 when omitted. */
  accentColor?: string;
}

/**
 * Mixed-colour store line: white text, game title and store name in accent.
 * Mobile variant is sized off the 412 Icon Drop artboard; desktop has its own
 * line sized off the 873 artboard.
 */
export const ThankYouStoreLineMobile = ({ gameName, storePlatform, accentColor }: ThankYouStoreLineProps) => {
  const accent = accentColor ?? THANK_YOU_ACCENT_DEFAULT;
  return (
    <p
      className='whitespace-nowrap text-center'
      style={{
        marginTop: iconDropPx(ICON_DROP_PX.headlineGap),
        color: '#FFFFFF',
        fontSize: iconDropPx(ICON_DROP_PX.subcopy),
        fontWeight: 300,
        lineHeight: 1.45,
      }}
    >
      Get <span style={{ color: accent }}>{gameName}</span> on{' '}
      <span style={{ color: accent }}>{storePlatform}</span>
    </p>
  );
};

export const ThankYouStoreLineDesktop = ({ gameName, storePlatform, accentColor }: ThankYouStoreLineProps) => {
  const accent = accentColor ?? THANK_YOU_ACCENT_DEFAULT;
  return (
    <p
      style={{
        marginTop: desktopPx(DESKTOP_PX.copyGap),
        color: '#FFFFFF',
        fontSize: desktopPx(DESKTOP_PX.subcopy),
        fontWeight: 300,
        lineHeight: 1.45,
      }}
    >
      Get <span style={{ color: accent }}>{gameName}</span> on{' '}
      <span style={{ color: accent }}>{storePlatform}</span>
    </p>
  );
};
